import React from 'react';

const GroupOnlyPermanentIcon = () => (
    <svg
        className="visibility"
        viewBox="0 0 24 24"
        fill="none"
        width="24"
        height="24"
    >
        <path
            d="M9 11C10.1 11 11.1833 11.1294 12.25 11.3877C12.8518 11.5334 13.4479 11.7212 14.0391 11.9492C13.3878 12.7935 13 13.8513 13 15V15.1738C11.8353 15.5859 11 16.6941 11 18H3C2.45 18 1.97956 17.8038 1.58789 17.4121C1.19622 17.0204 1 16.55 1 16V15.2002C1 14.6336 1.14589 14.1127 1.4375 13.6377C1.72912 13.1628 2.11638 12.7998 2.59961 12.5498C3.63293 12.0331 4.68335 11.646 5.75 11.3877C6.81667 11.1294 7.9 11 9 11Z"
            fill="currentColor"
            fillOpacity="0.72"
        />
        <path
            d="M9 2C10.1 2 11.0419 2.39147 11.8252 3.1748C12.6085 3.95814 13 4.9 13 6C13 7.1 12.6085 8.04186 11.8252 8.8252C11.0419 9.60853 10.1 10 9 10C7.9 10 6.95814 9.60853 6.1748 8.8252C5.39147 8.04186 5 7.1 5 6C5 4.9 5.39147 3.95814 6.1748 3.1748C6.95814 2.39147 7.9 2 9 2Z"
            fill="currentColor"
            fillOpacity="0.72"
        />
        <path
            d="M15 2C16.1 2 17.0419 2.39147 17.8252 3.1748C18.6085 3.95814 19 4.9 19 6C19 7.1 18.6085 8.04186 17.8252 8.8252C17.0419 9.60853 16.1 10 15 10C14.8167 10 14.5831 9.97917 14.2998 9.9375C14.0166 9.89584 13.7829 9.84979 13.5996 9.7998C14.0495 9.26655 14.396 8.67528 14.6377 8.02539C14.8794 7.37539 15 6.7 15 6C15 5.3 14.8794 4.62461 14.6377 3.97461C14.396 3.32472 14.0495 2.73345 13.5996 2.2002C13.8329 2.11688 14.0665 2.06212 14.2998 2.03711C14.5331 2.01211 14.7667 2 15 2Z"
            fill="currentColor"
            fillOpacity="0.72"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 17C22.5523 17 23 17.4477 23 18V22C23 22.5523 22.5523 23 22 23H14C13.4477 23 13 22.5523 13 22V18C13 17.4477 13.4477 17 14 17H15V15C15 13.3431 16.3431 12 18 12C19.6569 12 21 13.3431 21 15V17H22ZM19 17V15C19 14.4477 18.5523 14 18 14C17.4477 14 17 14.4477 17 15V17H19Z"
            fill="currentColor"
            fillOpacity="0.72"
        />
    </svg>
);

export default GroupOnlyPermanentIcon;
